import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css"; // Tailwind + theme CSS
import { ThemeProvider } from "./components/ThemeContext";

// Example user object (replace with real auth state)
const user = null;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider user={user}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
